const EMPTY_DRAFT_FIELD = '<p><br></p>';

export default EMPTY_DRAFT_FIELD;
export const SERVICE_AREA_TYPE_NATIONAL = 'national';
export const SERVICE_AREA_TYPE_STATE = 'state';
